import { render, staticRenderFns } from "./ChatIcon.vue?vue&type=template&id=45a6530c&scoped=true"
import script from "./ChatIcon.vue?vue&type=script&lang=js"
export * from "./ChatIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a6530c",
  null
  
)

export default component.exports